export const types = {
  GET_TEAMS: 'teams/GET_TEAMS',
  GET_TEAMS_SUCCESS: 'teams/GET_TEAMS_SUCCESS',
  GET_TEAMS_FAILED: 'teams/GET_TEAMS_FAILED',
};
